import './event.js';

/**
 * Reasons for why the session was automatically closed. Manually closed
 * sessions have no associated reason.
 */
let SessionClosedReason;

(function (SessionClosedReason) {
  SessionClosedReason["Broken"] = "broken";
  SessionClosedReason["RemoteClosed"] = "remoteclosed";
})(SessionClosedReason || (SessionClosedReason = {}));

export { SessionClosedReason as S };
